import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MinimalNavbar.css";

const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/quiz", label: "Quiz" },
  { to: "/partage", label: "Partage" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

const MinimalNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(prev => !prev);

  return (
    <nav className="navbar">
      <div className="navbar-header">
        <button className="burger-menu" onClick={toggleMenu}>
          ☰
        </button>
      </div>

      <div className={`navbar-links ${isOpen ? "open" : ""}`}>
        {navLinks.map(({ to, label }) => (
          <Link key={to} to={to} className="navbar-link" onClick={() => setIsOpen(false)}>
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MinimalNavbar;
